<template>
  <component
    :is="isExternal ? 'a' : 'router-link'"
    :href="isExternal ? target : null"
    :to="!isExternal ? target : null"
    class="relative w-full inline-flex items-center cursor-pointer
           justify-start py-4 pl-6 pr-12 
           overflow-hidden font-semibold 
           text-skin-b-list-base transition-all 
           duration-200 ease-in-out sm:hover:pl-16 sm:hover:pr-6 group"
    :aria-label="`Navigate to ${title}`"
    v-bind="isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {}"
  >
    <!-- Hover background -->
    <span class="absolute bottom-0 left-0 w-full h-full transition-all duration-200 ease-in-out 
                 rounded-lg sm:group-hover:bg-skin-active128/10"></span>

    <!-- Right arrow icon -->
    <span class="absolute right-0 pr-4 duration-200 ease-out sm:group-hover:translate-x-12">
      <IconArrowRight class="w-8 h-8 text-skin-base"/>
    </span>

    <!-- Left dynamic icon -->
    <span class="absolute left-0 pl-4 sm:-translate-x-14 sm:group-hover:translate-x-0 ease-out duration-200">
      <component :is="iconComponent" v-if="iconComponent" class="w-8 h-8" />
    </span>

    <!-- Blue ping dot -->
    <span
      v-if="showPing"
      class="absolute flex h-3 w-3 top-2.5 -translate-x-4 sm:group-hover:-translate-x-14 ease-out duration-200"
    >
      <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
      <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
    </span>

    <!-- Main Title -->
    <span class="relative pl-10 sm:pl-0 text-left text-xl sm:text-2xl duration-200 ease-out sm:group-hover:font-bold">
      {{ title }}
    </span>

    <!-- Subtitle (desktop) -->
    <span
      v-if="subtitle"
      class="hidden sm:inline-block text-skin-b-list-mute text-left text-base sm:text-xl duration-200 ease-out sm:group-hover:font-bold"
    >
      &nbsp;&nbsp;&bull;&nbsp;&nbsp;{{ subtitle }}
    </span>

    <!-- Subtitle (mobile) -->
    <span
      v-if="subtitle"
      class="inline-block sm:hidden text-skin-b-list-mute text-right text-base duration-200 ease-out"
    >
      &nbsp;({{ subtitleshort || subtitle }})
    </span>
  </component>
</template>


<script>
import IconArrowRight from '../icons/IconArrowRight.vue';
import IconBackup from '../icons/IconBackup.vue';
import IconEasyCheckIn from '../icons/IconEasyCheckIn.vue';
import IconPowerManagement from '../icons/IconPowerManagement.vue';
import IconEditSquare from '../icons/IconEditSquare.vue';
import IconMail from '../icons/IconMail.vue';
import IconSecurity from '../icons/IconSecurity.vue';
import IconModbus from '../icons/IconModbus.vue';
import IconNetwork from '../icons/IconNetwork.vue';
import IconOcpp from '../icons/IconOcpp.vue';
import IconPara14 from '../icons/IconPara14.vue';
import IconPublicShare from '../icons/IconPublicShare.vue';
import IconSolarPower from '../icons/IconSolarPower.vue';
import IconUpdate from '../icons/IconUpdate.vue';

export default {
  name: 'SettingsItem',
  components: {
    IconArrowRight,
    IconBackup,
    IconEasyCheckIn,
    IconPowerManagement,
    IconEditSquare,
    IconMail,
    IconSecurity,
    IconModbus,
    IconNetwork,
    IconOcpp,
    IconPara14,
    IconPublicShare,
    IconSolarPower,
    IconUpdate
  },
  props: {
    title: String,
    subtitle: {
      type: String,
      default: ''
    },
    subtitleshort: String,
    target: String,
    icon: String,
    showPing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconComponent() {
      const icons = {
        editsquare: 'IconEditSquare',
        solarpower: 'IconSolarPower',
        publicshare: 'IconPublicShare',
        easycheckin: 'IconEasyCheckIn',
        powermanagement: 'IconPowerManagement',
        ocpp: 'IconOcpp',
        modbus: 'IconModbus',
        mail: 'IconMail',
        security: 'IconSecurity',
        update: 'IconUpdate',
        backup: 'IconBackup',
        network: 'IconNetwork',
        para14: 'IconPara14'
      };
      return icons[this.icon] || null;
    },
    isExternal() {
      return this.target?.startsWith('http://') || this.target?.startsWith('https://');
    }
  }
};
</script>
